import LoginAlert from "components/ModalLogin/LoginAlert"
import { Modal } from "components/ui"
import useStore from "components/ui/Context"
import { getAccessToken } from "lib/Cookies"
import Image from "next/legacy/image"
import Link from "next/link"
import { useRouter } from "next/router"
import { useEffect, useRef, useState } from "react"

function CardRecommend({ name, thumbnail_1, thumbnail_2, id, is_protected, typeCard = "square" }) {
  const router = useRouter()
  const { toggleModalLogin, userInfo, signKey } = useStore()
  const isMonter = useRef(false)
  const [isModal, setIsModal] = useState(false)
  const [srcImage, setSrcImage] = useState(typeCard === "square" ? thumbnail_1 : thumbnail_2)

  function onClick(e) {
    if (is_protected && !getAccessToken()) {
      isMonter.current = true
      setIsModal(true)
      // toggleModalLogin()
      e.preventDefault()
      return false
    }
  }

  function onClose() {
    setIsModal(false)
  }

  function onNext() {
    toggleModalLogin()
    setIsModal(false)
  }

  useEffect(() => {
    if (isMonter.current && userInfo?.fullname) {
      router.push(`/recommend?block_id=${id}`)
    }
  }, [userInfo])

  useEffect(() => {
    if (isMonter.current && signKey) {
      router.push(`/recommend?block_id=${id}`)
    }
  }, [signKey])

  return (
    <>
      <Link href={`/recommend?block_id=${id}`}>
        <div
          className={`relative flex bg-[#202020] rounded-xl border border-transparent box-content hover:border-white`}
        >
          <Image
            src={srcImage}
            width={346}
            height={typeCard === "square" ? 346 : typeCard === "rectangleSm" ? 426 : 538}
            alt={name}
            className={`rounded-xl max-md:rounded-[14px] object-cover ${
              typeCard === "square"
                ? "aspect-square"
                : typeCard === "rectangleSm"
                ? "aspect-[173/213]"
                : "aspect-[173/269]"
            }`}
            onError={() => setSrcImage("/placeholder_video.svg")}
          />
          <div className="absolute bottom-0 left-0 w-full">
            <div className="m-3 max-md:m-0 bg-[#1313133D] max-md:bg-[#2E2E2E] p-3 rounded-[14px] max-md:rounded-t-none flex flex-col gap-[10px] backdrop-blur-xl">
              <span className="uppercase font-bold text-xs md:text-base md:leading-5">{name}</span>
            </div>
          </div>
        </div>
      </Link>
      <Modal
        isOpen={isModal}
        onCancel={() => {
          setIsModal(false)
        }}
        showIcon={false}
      >
        <LoginAlert
          onCancel={() => {
            setIsModal(false)
          }}
          onNext={onNext}
        />
      </Modal>
    </>
  )
}
export default CardRecommend
